import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { polarisEmbeddedIdeasRoute } from '@jira/router-routes__polaris-routes/src/polarisEmbeddedIdeasRoute.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { polarisEmbeddedIdeasEntryPoint } from './ui/embedded-ideas/polarisEmbeddedIdeasEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

export const polarisEmbeddedIdeasRouteEntry: Route = createEntry(polarisEmbeddedIdeasRoute, () => ({
	// Strict Mode is disabled across all Polaris (JPD) routes: the JPD app is not compatible with
	// Strict Mode's double-invocation of render and effects, so it stays off for this route too.
	isStrictModeEnabled: false,
	group: 'polaris',
	ufoName: 'jpd.embedded-view',

	layout: chromelessLayout,

	resources: [...jiraSpaResources()],

	entryPoint() {
		return fg('jpd_embedded_spa_routes') ? polarisEmbeddedIdeasEntryPoint : notFoundPageEntrypoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
		cspOverride: {
			frameAncestors: '*',
		},
	},
}));
